/**
 * @desc: - 冷热遗漏按钮开关
 * @author: ammo
 */

 import React from 'react';

 export default  class MissHotCold extends React.Component{

 	constructor(props){
 		super(props)
 		this.handleTypeChange = this.handleTypeChange.bind(this);
 	}

	// 切换
	handleTypeChange(type, isSub){
		const {handleChange} = this.props;
		handleChange(type, isSub);
	}

	render(){
		const {type, subType} = this.props;
		return(
			<div className="button-miss-container">
				<div className='switcher'>
					<span onClick={this.handleTypeChange.bind(this, 1, false)} className={type == 1 ? 'active' : ''}>遗漏</span>
					<span onClick={this.handleTypeChange.bind(this, 2, false)} className={type == 2 ? 'active' : ''}>冷热</span>
				</div>
				{
					type == 1 ? 
						<div className='options'>
							<span onClick={this.handleTypeChange.bind(this, 1, true)} className={subType == 1 ? 'active' : ''} >当前遗漏</span>
							<span onClick={this.handleTypeChange.bind(this, 2, true)} className={subType == 2 ? 'active' : ''} >最大遗漏</span>
						</div> : null
				}
				{
					type == 2 ? 
					<div className='options'>
						<span onClick={this.handleTypeChange.bind(this, 1, true)} className={subType == 1 ? 'active' : ''} >30期</span>
						<span onClick={this.handleTypeChange.bind(this, 2, true)} className={subType == 2 ? 'active' : ''} >50期</span>
						<span onClick={this.handleTypeChange.bind(this, 3, true)} className={subType == 3 ? 'active' : ''} >100期</span>
					</div> : null
				}
			</div>
		)
	}

 }